import React from "react";
import { useTranslation } from "react-i18next";
import { Dialog } from "@progress/kendo-react-dialogs";
import { Grid } from "@material-ui/core";
import { ButtonHLPure, TextAreaHLPure} from "..";

/* === Custom component title for dialog === */
const CustomDeleteSignatureTitleBar = (props) => {
  const { t } = useTranslation();
  const customTitleBarStyles = {
    fontSize: '20px',
    fontFamily: "Quicksand, sans-serif",
    fontWeight: "600"

  };
  return (
    <div style={customTitleBarStyles}>
      <span>{t("dialogDeleteSignature.dialogTittleDeleteSignRequest")}</span>
    </div>
  );
};

const DialogDeleteSignaturePure = (props) => {
  const { t } = useTranslation();

  const labelMessageDeleteStyles = {
    fontSize: "14px",
    fontFamily: "Quicksand, sans-serif",
    color: "#000000DE",
    fontWeight: "600"
  };
  const containerButtonsGroupStyles = {
    display: "flex",
    justifyContent: "end",
    alignItems: "center",
    gap: "10px",
    marginTop: "20px",
  };
  const formAndTextAreaContainerStyles = {
    maxWidth: "525px",
    padding: "24px",
    paddingTop: "0px",
  };
  const containerLabelWarningStyles = {
    width: "100%",
    height: "auto",
    textAlign: "center",
    backgroundColor: "#DEDEDE",
    maxWidth: "525px",
  };
  const parrafWarningStyles = {
    margin: "0px",
    padding: "15px 35px 15px 35px",
    fontStyle: "italic",
  };
  return (
    <React.Fragment>
      {props?.signatureRequest?.signRequest?.signRequestStatus?.id ===
        Number(process.env.REACT_APP_SIGN_REQUEST_STATUS_PENDING) &&
        props.userCanCancelSignRequest !== null &&
        props.userCanCancelSignRequest === true ? (
        <ButtonHLPure
          nameBtn={t("signatureRequestDetailView2.buttonCancelSignRequest")}
          onClickBtn={props.toggleDialogDeleteRequest}
          primary={false}
        />
      ) : null}

      {props.visibleDialogDeleteRequest && (
        <div className="dialogContent">
          <Dialog
            title={<CustomDeleteSignatureTitleBar />}
            onClose={props.toggleDialogDeleteRequest}
          >
            {props.signRequestHasAlmostASign != null &&
              props.signRequestHasAlmostASign === true ? (
              <div style={containerLabelWarningStyles}>
                <p style={parrafWarningStyles}>
                  {t("dialogDeleteSignature.warningSignRequestHasSignsApplied")}
                </p>
              </div>
            ) : null}
            {/* Container global */}
            <Grid
              container
              style={formAndTextAreaContainerStyles}
              xs={12}
              lg={12}
              md={12}
              sm={12}
              es={12}
            >
              {/* Label y TextArea */}
              <Grid
                item
                xs={12}
                lg={12}
                md={12}
                sm={12}
                es={12}
                style={{ margin: '0' }}
              >
                <div style={{ backgroundColor: "#eeeef1", marginBottom: '20px', padding: '10px 20px' }}>
                  <p style={labelMessageDeleteStyles}>
                    {t("dialogDeleteSignature.AreYouShureToDelete")}{" "}
                    <span style={{ fontWeight: 600 }}>
                      {props.signRequestNameDelete}{", "}
                    </span>
                    {t("dialogDeleteSignature.AreYouShureToDelete2")}
                  </p>
                </div>
                <div>
                  <TextAreaHLPure
                    labelTextArea={t(
                      "dialogDeleteSignature.placeholderDeleteReason"
                    )} 
                    characterLimit={500}
                    handleChangeTextArea={props.handleCommentsDelete}
                    required
                    rowsTextArea={5}
                    valueTextData={props.commentsDelete}
                  />
                </div>
                {props.errorCommentsDelete === true ? (
                  <p className="hint-message-error-sign-request">
                    {t("dialogDeleteSignature.errorCommnets")}
                  </p>
                ) : null}
              </Grid>

              {/* Grupo de botones */}
              <Grid
                item
                xs={12}
                lg={12}
                md={12}
                sm={12}
                es={12}
                style={containerButtonsGroupStyles}
              >
                <ButtonHLPure
                  onClickBtn={props.toggleDialogDeleteRequest}
                  nameBtn={t("dialogDeleteSignature.buttonCancel")}
                />
                <ButtonHLPure
                  primary
                  onClickBtn={props.deleteSignRequest}
                  nameBtn={t("dialogDeleteSignature.buttonSend")}
                />
              </Grid>
            </Grid>
          </Dialog>
        </div>
      )}
    </React.Fragment>
  );
};

export { DialogDeleteSignaturePure as default };
